import React , { useState , useEffect , useContext } from "react";
import {useNavigate  } from "react-router-dom";
import  { WebAssetsContext }  from "../App";
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';

const  Slider = (props) => {

  const WebAssets = useContext(WebAssetsContext);
  const api = WebAssets.apiURL;
  const navigate = useNavigate();
  const [sliders, setSliders] = useState([]);
    const fetchData = () => {
      fetch(api+"getslider")
        .then(res => res.json())
        .then((result) => {
            if(result.status == true)
            {
              setSliders(result.response);
            }
          }
        )
      }
    useEffect(() => {
        fetchData();
    },[])
   

  return (
    <>
      <div className="section-body">
                  <div className="row">
                    <div className="col-12">
                        <div className="card">
                        <div className="pt-4 pl-4 pr-4">
                        <div className="card-header pl-0 pr-0 w-50 float-left">
                                    <h4 className="headercolor" >Slider List</h4>
                                </div>
                                <div className="float-right">
                                          <button  className="btn btn-icon icon-left btn-primary"><i className="fas fa-plus"></i> Add Slider</button>
                                    </div>
                               
                                    </div>
                            <div className="card-body pl-4 pr-4 pb-4 pt-0">
                                <div className="table-responsive">
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th>S.NO</th>
                                                <th>Title</th>
                                                <th width={'120px'} >Status</th>
                                                <th width={'120px'} className="text-right">Action</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                          {sliders.length > 0 ? sliders.map((slider , i)  => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td>{slider.title}</td>
                                                
                                                <td>
                                                { slider.status == '1' ? <div className="badge badge-success">Complete</div> : ''}  
                                                
                                                { slider.status == '0' ? <div className="badge badge-danger">Pending</div> : ''}
                                              
                                                </td>

                                                <td className="text-right">

                                                <button  role="button"
                                                  id={'edit_'+slider.id}
                                                  className="btn btn-icon btn-primary mr-2" data-tooltip-content="Edit">
                                                    <i className="far fa-edit"></i>
                                                    </button>
                                                  <Tooltip anchorId={'edit_'+slider.id}  />

                                                  <button role="button"  id={'delete_'+slider.id} className="btn btn-icon btn-danger" data-tooltip-content="Delete" ><i className="far fa-trash-alt"></i></button>
                                                  <Tooltip anchorId={'delete_'+slider.id}  />
                                                </td>
                                               
                                            </tr>
                                            ))  : 

                                            <tr><td colSpan="10" className="text-center">Data not yet found. </td>
                                            </tr> 
                                           }
                                            
                                          </tbody>
                                    </table>
                                  </div>
                            </div>
                        </div>
                      </div>
                  </div>
                  </div>
    </>

  );
}

export default Slider;
